import { render } from "./Hotkeys.vue?vue&type=template&id=5c5908fc"
import script from "./Hotkeys.vue?vue&type=script&lang=js"
export * from "./Hotkeys.vue?vue&type=script&lang=js"
script.render = render

export default script